import React from 'react';

import SkeletonHitCard from 'Components/Card/HitCard/SkeletonHitCard';
import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';
import SkeletonImg from 'Components/Skeleton/SkeletonImg';
import headerBannerSources from 'Features/FacetCategory/helpers/headerBannerSources';

/**
 * Facet page (/publishers/:slug etc., FacetSearch) while it loads: the header image (md and up, when the facet has
 * one), the title and description, then ProductListing with its filters closed (controls and a 2/3/4 column grid).
 * The facet index pages (FacetOrderedList, also in this group) show it too.
 * Slots: `name` (text), `header-image` (image URL).
 */
export default function FacetPageSkeleton() {
  return (
    <div className="FacetPageSkeleton">
      <div className="FacetPageSkeleton__banner" data-skeleton-if="header-image">
        <SkeletonImg slot="header-image" sizes="100vw" sources={headerBannerSources} />
      </div>

      <div className="container FacetPageSkeleton__header">
        <SkeletonBlock text tag="h1" slot="name" className="FacetPageSkeleton__name" />
        <SkeletonBlock className="FacetPageSkeleton__line" />
        <SkeletonBlock className="FacetPageSkeleton__line" />
        <SkeletonBlock className="FacetPageSkeleton__line FacetPageSkeleton__line--more d-lg-none" />
      </div>

      <section className="container FacetPageSkeleton__listing">
        <div className="FacetPageSkeleton__controls">
          <div className="FacetPageSkeleton__controlGroup">
            <SkeletonBlock className="FacetPageSkeleton__button FacetPageSkeleton__button--filter" />
            <SkeletonBlock className="FacetPageSkeleton__showing d-none d-lg-block" />
          </div>
          <div className="FacetPageSkeleton__controlGroup">
            <SkeletonBlock className="FacetPageSkeleton__button d-none d-lg-block" />
            <SkeletonBlock className="FacetPageSkeleton__button FacetPageSkeleton__button--sort" />
          </div>
        </div>

        <div className="FacetPageSkeleton__grid">
          {/* As ProductListingHits renders while searching */}
          <SkeletonHitCard
            ProductListing
            numberOfCards={12}
            xsSize={12}
            smSize={12}
            mdSize={12}
            lgSize={12}
          />
        </div>
      </section>
    </div>
  );
}
